import { FlatButton } from '@framework/ui/atoms';
import { CreateWorkspaceModal } from '@user/pages/GroupPage/createWorkspace/CreateWorkspaceModal';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  groupId: string;
  userId: string;
};

export const CreateWorkspaceButton: React.FC<Props> = ({ groupId, userId }: Props) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const handleOpen = useCallback(() => setModalOpen(true), []);
  const handleClose = useCallback(() => setModalOpen(false), []);

  return (
    <>
      <FlatButton color="brand" size="sm" className="w-50 px-3 py-2" onClick={handleOpen}>
        {t('sidebar.tree.createWorkspace')}
      </FlatButton>

      <CreateWorkspaceModal groupId={groupId} userId={userId} isOpen={modalOpen} onClose={handleClose} />
    </>
  );
};
